module.exports = __webpack_public_path__ + "static/img/未标题-9.7ae3fbf2.png";